<template>
  <div class="flex">
    <img :src="require(`@/assets/${imageSrc}`)" class="icon" alt=""/>
    <span>{{ description }}</span>
  </div>
</template>

<script>
export default {
  name: "LegendItem",
  props: {
    imageSrc: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.flex {
  display: flex;
  align-items: center;
}

.icon {
  width: 36px;
  height: 36px;
}
</style>